import {WarenkorbEntry} from './warenkorb-entry';

export class WarenkorbKategorie {
  view_slug: string;
  label: string;
  positionen: WarenkorbEntry[];
}
